var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 14.6L16.15 7.55L14.75 6.15L9.1 11.8L6.25 8.95L4.85 10.35L9.1 14.6ZM10.5 20C9.11667 20 7.81667 19.7373 6.6 19.212C5.38333 18.6873 4.325 17.975 3.425 17.075C2.525 16.175 1.81267 15.1167 1.288 13.9C0.762667 12.6833 0.5 11.3833 0.5 10C0.5 8.61667 0.762667 7.31667 1.288 6.1C1.81267 4.88333 2.525 3.825 3.425 2.925C4.325 2.025 5.38333 1.31233 6.6 0.787C7.81667 0.262333 9.11667 0 10.5 0C11.8833 0 13.1833 0.262333 14.4 0.787C15.6167 1.31233 16.675 2.025 17.575 2.925C18.475 3.825 19.1873 4.88333 19.712 6.1C20.2373 7.31667 20.5 8.61667 20.5 10C20.5 11.3833 20.2373 12.6833 19.712 13.9C19.1873 15.1167 18.475 16.175 17.575 17.075C16.675 17.975 15.6167 18.6873 14.4 19.212C13.1833 19.7373 11.8833 20 10.5 20ZM10.5 18C12.7333 18 14.625 17.225 16.175 15.675C17.725 14.125 18.5 12.2333 18.5 10C18.5 7.76667 17.725 5.875 16.175 4.325C14.625 2.775 12.7333 2 10.5 2C8.26667 2 6.375 2.775 4.825 4.325C3.275 5.875 2.5 7.76667 2.5 10C2.5 12.2333 3.275 14.125 4.825 15.675C6.375 17.225 8.26667 18 10.5 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.ce138e7cd8227795f79a99c282378e17.svg";
export { ForwardRef as ReactComponent };